"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTokenAboutToExpire = exports.getUserIdFromToken = exports.isTokenExpired = exports.getDecodedToken = exports.getToken = exports.saveToken = exports.initialState = void 0;
var gen_types_1 = require("./graphql/gen-types");
var jwt = __importStar(require("jsonwebtoken"));
exports.initialState = {
    clientId: 0,
    clientName: '',
    email: '',
    firstName: '',
    id: 0,
    lastName: '',
    privileges: [],
    role: gen_types_1.Roles.None,
};
var saveToken = function (token) {
    try {
        sessionStorage.setItem('resolvex-token', JSON.stringify(token));
        return true;
    }
    catch (_a) {
        return false;
    }
};
exports.saveToken = saveToken;
var getToken = function () {
    var token = sessionStorage.getItem('resolvex-token');
    if (token) {
        return JSON.parse(token);
    }
    return '';
};
exports.getToken = getToken;
var getDecodedToken = function () {
    var token = sessionStorage.getItem('resolvex-token');
    if (token) {
        return jwt.decode(JSON.parse(token));
    }
    return exports.initialState;
};
exports.getDecodedToken = getDecodedToken;
var isTokenExpired = function () {
    var token = (0, exports.getDecodedToken)();
    if (token && token['exp']) {
        return isExpired(token['exp']);
    }
    return true;
};
exports.isTokenExpired = isTokenExpired;
var getUserIdFromToken = function () {
    var id = (0, exports.getDecodedToken)().id;
    return id;
};
exports.getUserIdFromToken = getUserIdFromToken;
var isExpired = function (timestamp) {
    var utcnow = Math.floor(Date.now() / 1000);
    return timestamp < utcnow;
};
var isTokenAboutToExpire = function () {
    var token = (0, exports.getDecodedToken)();
    if (token && token['exp']) {
        var currentTime = Math.floor(Date.now() / 1000);
        var fiveMinutesInSeconds = 5 * 60;
        var secondsLeft = token['exp'] - currentTime;
        return {
            isExpiring: secondsLeft <= fiveMinutesInSeconds && secondsLeft > 0,
            timeLeft: secondsLeft > 0 ? secondsLeft : null,
        };
    }
    return { isExpiring: false, timeLeft: null };
};
exports.isTokenAboutToExpire = isTokenAboutToExpire;
//# sourceMappingURL=auth.js.map